<template>
  <layout
    :key="uniquePageKey"
    :header="header"
    :footer="footer"
    :country="country"
  >
    <loading v-if="$fetchState.pending" />
    <div v-else class="flex-1 pt-8">
      <app-banner-landing
        v-if="sectionAppBannerLanding"
        :section="sectionAppBannerLanding"
      />
      <usps-block enable-cta is-last />
    </div>
  </layout>
</template>

<script>
import createPageMixin from '~/mixins/page'
import Layout from '~/components/layout/default'
import { firstOfCollection } from '~/utils/collection'
import { contentfulToImage } from '~/utils/image'
import { UspsBlock, Loading } from '~/components/organisms'
import { AppBannerLanding } from '~/components/molecules'

export default {
  components: {
    UspsBlock,
    Layout,
    Loading,
    AppBannerLanding,
  },
  mixins: [
    createPageMixin({
      pageType: 'app-banner',
      cloudfrontCache: true,
      seo: {
        origin: 'contentful',
      },
    }),
  ],
  data() {
    return {}
  },
  async fetch() {
    const appLandingPageRequest = this.appLandingPageRequest()
    const {
      data: { appLandingPageCollection },
    } = await appLandingPageRequest

    this.contentfulPageData = firstOfCollection(appLandingPageCollection)
  },
  computed: {
    sectionAppBannerLanding() {
      const sectionAppBannerLanding = firstOfCollection(
        this.contentfulPageData.sectionsCollection
      )
      if (!sectionAppBannerLanding) return null
      return {
        ...sectionAppBannerLanding,
        imageDesktop: contentfulToImage(sectionAppBannerLanding.imageDesktop),
        imageMobile: contentfulToImage(sectionAppBannerLanding.imageMobile),
      }
    },
  },
  methods: {
    appLandingPageRequest() {
      return this.$contentful('appPage')({
        locale: this.$store.getters['context/cmsLocale'],
      })
    },
  },
}
</script>
